/**
 * Constantes para nombres de métodos del hub SignalR
 */
export const SIGNALR_METHODS = {
  /** Evento que recibe datos de escaneo QR desde el middleware */
  RECEIVE_QR: 'ReceiveQR',

  /** Evento que indica que se deben refrescar los datos de lockers */
  REFRESH_LOCKERS: 'refreshLockers',
} as const;

/**
 * Constantes para estados de conexión SignalR
 */
export const SIGNALR_CONNECTION_STATE = {
  /** Conexión establecida y activa */
  CONNECTED: 'Connected',

  /** Intentando reconectar después de una pérdida de conexión */
  RECONNECTING: 'Reconnecting',

  /** Sin conexión activa */
  DISCONNECTED: 'Disconnected',
} as const;
